import { BrowserModule } from '@angular/platform-browser';
import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {MatSliderModule} from '@angular/material/slider';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { MatIconModule } from '@angular/material/icon';
import { RepaymentHomeComponent } from './repayment-home/repayment-home.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FooterComponent } from './footer/footer.component';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTableModule } from '@angular/material/table';
import { enableProdMode } from '@angular/core';

import { 
	IgxCategoryChartModule,
	IgxLegendModule
 } from "igniteui-angular-charts";
import { PendingChangesGuard } from './pending-changes-guard.guard';
import { HomeTwoComponent } from './home-two/home-two.component';
import { HomeThreeComponent } from './home-three/home-three.component';
import { HomeFiveComponent } from './home-five/home-five.component';
import { HomeOneComponent } from './home-one/home-one.component';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { SubscribeDialogComponent } from './subscribe-dialog/subscribe-dialog.component';
import { PropertyIconComponent } from './property-icon/property-icon.component';
import { BreakdownSectionComponent } from './breakdown-section/breakdown-section.component';
import { MatMenuModule } from '@angular/material/menu';
import { ScheduleComponent } from './schedule/schedule.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    RepaymentHomeComponent,
    FooterComponent,
    HomeTwoComponent,
    HomeThreeComponent,
    HomeFiveComponent,
    HomeOneComponent,
    SubscribeDialogComponent,
    PropertyIconComponent,
    BreakdownSectionComponent,
    ScheduleComponent
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    MatIconModule,
    MatSliderModule,
    FormsModule,
    FontAwesomeModule,
    IgxCategoryChartModule,
    IgxLegendModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    MatDialogModule,
    MatMenuModule,
    MatTableModule
  ],
  providers: [PendingChangesGuard],
  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule { }
